// extracted by css-extract-rspack-plugin
export default {"cls1":"SocialProofUniversityFooter-cls1_Nky","cls2":"SocialProofUniversityFooter-cls2_xFP SocialProofUniversityFooter-cls1_Nky","dark":"SocialProofUniversityFooter-dark_8n1"};